<template lang="pug">
    div
        v-progress-linear(v-if="loading" :indeterminate="true")
        v-card(outlined v-if="test")
            v-card-title {{ $showLocalizedField(test.name, locale).text }}

            v-card-text
                v-row
                    v-col(cols="12" sm="12" md="4" lg="3"  v-for="question in questions" :key="question.id")
                        v-card(outlined)
                            v-system-bar(height="50") Вопрос {{ question.srt }}
                                v-spacer
                                v-btn.ml-1(outlined icon small @click="editExistQuestion(question)")
                                    v-icon.mr-0 mdi-pencil
                                v-btn.ml-1(outlined icon small @click="delQuestion(question)") 
                                    v-icon.mr-0 mdi-delete
                            v-card-text {{ $showLocalizedField(question.questiontext, locale).text }}
                            v-card-text Количество вариантов - {{ question.variantsCount }} 
                                a(@click="showEditVariants(question)") Редактировать варианты

                v-row
                    v-btn(@click="addQuestion()") Добавить задание

        v-dialog(v-model="questionDialog" max-width="900" scrollable)
            v-card(v-if="editQuestion") 

                v-card-title(style="background:#e0e0e0;") Задание {{ editQuestion.srt }}
                    v-spacer
                    v-btn.ml-1(outlined icon small @click="closeQuestionDialog()")
                         v-icon.mr-0 mdi-close

                v-card-text
                    v-form(v-on:submit.prevent="onSubmit")
                        .mb-3
                        v-text-field(outlined v-model="editQuestion.srt" label="Порядок вывода" required)

                        v-select(outlined v-model="editQuestion.type" :items="types")

                        v-card.mb-7(outlined)
                            v-card-title Локализованое поле Текст задания

                            v-card-text 
                                v-text-field(v-for="(questiontext,index) in editQuestion.questiontext" :key="index" v-model="questiontext.text" :label="'Текст вопроса ('+questiontext.locale+')'" @input="questiontext.validate(index)" @blur="questiontext.validate(index)" :error-messages="questiontext.errors" outlined)
                                    v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField(editQuestion, 'questiontext',index)")
                                        v-icon mdi-close
                                v-menu(v-if="availableFieldLocales(editQuestion, 'questiontext').length > 0" open-on-hover)
                                    template(v-slot:activator="{ on }")
                                        v-btn(v-on="on") Добавить локализацию
                                    v-card
                                        v-list-item(v-for="item in availableFieldLocales(editQuestion, 'questiontext')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField(editQuestion, 'questiontext',item)")

                        v-card-actions
                            v-btn(type="submit") Сохранить

        v-dialog(v-model="variantsDialog" max-width="1000" scrollable)
            v-card(v-if="editQuestion")
                v-card-title(style="background:#e0e0e0;") Варианты ответа на задание {{ editQuestion.srt }}
                    v-spacer
                    v-btn.ml-1(outlined icon small @click="hideVariantsDialog()")
                         v-icon.mr-0 mdi-close

                v-card-text
                    v-progress-linear(v-if="variantsLoading" :indeterminate="true")
                    v-card-text
                        v-card.mb-7(v-for="variant in variants" :key="variant.id")
                            v-system-bar(height="50") Вариант {{ variant.srt }}
                                v-spacer
                                v-btn.ml-1(outlined icon small @click="editExistVariant(variant)")
                                    v-icon.mr-0 mdi-pencil
                                v-btn.ml-1(outlined icon small @click="delVariant(variant)") 
                                    v-icon.mr-0 mdi-delete

                            v-card-text 
                                div {{ $showLocalizedField(variant.varianttext, locale).text }}
                                div Правильный вариант {{ variant.isCorrect }}


                v-card-actions
                    v-btn(@click="addVariant()") Добавить вариант ответа


        v-dialog(v-model="variantDialog" max-width="900" scrollable)
            v-card(v-if="editVariant")
                v-card-title(style="background:#e0e0e0;") Вариант {{ editVariant.srt }}
                    v-spacer
                    v-btn.ml-1(outlined icon small @click="closeVariantDialog()")
                         v-icon.mr-0 mdi-close

                v-card-text 
                    v-form(v-on:submit.prevent="onSubmitVariant")
                        v-card-text
                            v-text-field(outlined v-model="editVariant.srt" label="Порядок вывода" required)

                            v-checkbox(v-model="editVariant.isCorrect" label="Правильный вариант")

                            v-card.mb-7(outlined)
                                v-card-title Локализованое поле Текст варианта

                                v-card-text 
                                    v-text-field(v-for="(varianttext,index) in editVariant.varianttext" :key="index" v-model="varianttext.text" :label="'Текст варианте ('+varianttext.locale+')'" @input="varianttext.validate(index)" @blur="varianttext.validate(index)" :error-messages="varianttext.errors" outlined)
                                        v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField(variant,'varianttext',index)")
                                            v-icon mdi-close
                                    v-menu(v-if="availableFieldLocales(editVariant,'varianttext').length > 0" open-on-hover)
                                        template(v-slot:activator="{ on }")
                                            v-btn(v-on="on") Добавить локализацию
                                        v-card
                                            v-list-item(v-for="item in availableFieldLocales(editVariant,'varianttext')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField(editVariant, 'varianttext',item)")
                        v-card-actions
                            v-btn(type="submit") Сохранить

        v-dialog(v-model="blockOverlay" width="auto")
            v-card.pa-10
                v-progress-circular(indeterminate size=128 color="red")
</template>

<script>
    import { mapState } from "vuex";

    import { testsService } from '@/_services'

    export default {
        mounted () {
            this.loadTest()
            this.loadQuestions()
        },
        computed: {
            ...mapState(['locale','locales']),

            defaultLocale(){
                return this.locales.filter(f => f.default == true)[0]
            }
        },
        methods: {
            loadTest(){
                this.loading = true
                testsService.get(this.$route.params.id).then(data=>{
                    this.test = data
                    this.loading = false
                })
            },
            loadQuestions(){
                this.loading = true
                testsService.loadQuestions(this.$route.params.id).then(data=>{
                    this.questions = data
                    this.loading = false
                })
            },
            loadVariants(){
                this.variantsLoading = true
                testsService.loadVariants(this.editQuestion.id).then(data=>{
                    this.variants = data
                    this.variantsLoading = false
                })
            },
            showQuestionDialog(){
                this.questionDialog = true
            },
            closeQuestionDialog(){
                this.questionDialog = false
            },
            showEditVariants(question){
                this.editQuestion = question
                this.variantsDialog = true
                this.loadVariants()
            },
            hideVariantsDialog(){
                this.variantsDialog = false
                this.editQuestion = null
                this.variants = null
            },
            showVariantDialog(){
                this.variantDialog = true
            },
            closeVariantDialog(){
                this.variantDialog = false
            },
            addQuestion(){
                this.editQuestion = {
                    testid:this.test.id,
                    srt:0,
                    type:0,
                    questiontext:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новый вопрос'
                        }
                    ]
                }

                this.assignEntityFieldFunctions(this.editQuestion,'questiontext')
                this.showQuestionDialog()
            },

            editExistQuestion(question){
                this.editQuestion = question
                this.assignEntityFieldFunctions(this.editQuestion,'questiontext')
                this.showQuestionDialog()
            },

            delQuestion(v){
                this.blockOverlay=true
                testsService.delQuestion(v.id).then(() => {
                    this.loadQuestions()
                    this.blockOverlay=false
                })
            },


            availableFieldLocales(entity, field){
                let locs = this.locales.filter(loc=>{
                    let dflt = !entity[field].some(f => f.locale == loc.value)
                    return dflt
                })
                return locs
            },

            assignEntityFieldFunctions(entity,fieldName){
                entity[fieldName].map(el => {this.addFunction(entity,fieldName,el)})
            },

            addFunction(entity, fieldName, field){
                let _self = entity
                this.$set(field,'errors',[])
                this.$set(field,'validate',function(index){
                    let err = []

                    if (_self[fieldName][index].text.trim() == '') {
                        err.push('Обязательное поле')
                    }
                    field.errors = err
                })
                return field
            },

            addLocalizedField(entity, field,locale){
                let exist = entity[field].some(f => f.locale == locale.value)
                if (!exist){
                    let defaultField = entity[field][0]

                    let newField = {}
                    this.$set(newField,'locale',locale.value)
                    this.$set(newField,'text',defaultField.text)

                    this.addFunction(entity, field,newField)
                    entity[field].push(newField)
                }
            },

            removeLocalizedField(entity, field,fieldIndex){
                entity[field].splice(fieldIndex, 1)
            },

            addVariant(){
                this.editVariant = {
                    srt:0,
                    questionid:this.editQuestion.id,
                    varianttext:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новый вариант'
                        }
                    ],
                    isCorrect:false
                }

                this.$set(this.editVariant,'srt',0)
                this.$set(this.editVariant,'isCorrect',false)

                this.assignEntityFieldFunctions(this.editVariant,'varianttext')

                this.showVariantDialog()
            },

            editExistVariant(variant){
                this.editVariant = variant
                this.assignEntityFieldFunctions(this.editVariant,'varianttext')
                this.showVariantDialog()
            },

            assignVariantsFieldsFunctions(){
                this.editQuestion.variants.map(el => {this.assignVariantFunctions(el)})
            },

            validate(){
                let hasErrors = false;
                if (!hasErrors) hasErrors = this.editQuestion.questiontext.some(t => t.errors.length > 0)
                return hasErrors
            },

            onSubmit(){
                if (!this.validate()){
                    this.$nextTick(() => {
                        testsService.saveQuestion(this.editQuestion).then(data=>{
                            this.loadTest()
                            this.loadQuestions()
                            this.questionDialog = false
                            this.editQuestion = null
                        })
                    })
                }
            },

            validateVariant(){
                let hasErrors = false;
                if (!hasErrors) hasErrors = this.editVariant.varianttext.some(t => t.errors.length > 0)
                return hasErrors
            },

            onSubmitVariant(){
                if (!this.validateVariant()){
                    this.$nextTick(() => {
                        testsService.saveVariant(this.editVariant).then(data=>{
                            this.loadVariants()
                            this.loadQuestions()
                            this.variantDialog = false
                            this.editVariant = null
                        })
                    })
                }
            },

            delVariant(v){
                this.blockOverlay=true
                testsService.delVariant(v.id).then(() => {
                    this.loadVariants()
                    this.loadQuestions()
                    this.blockOverlay=false
                })
            }
        },
        data() {
            return {
                loading:false,
                test:null,
                questions:null,
                editQuestion:null,
                questionDialog:false,

                variants:null,
                variantsLoading:false,
                variantsDialog:false,
                variantDialog:false,
                editVariant:null,

                blockOverlay: false,

                types:[
                    {
                        value:0,
                        text:'Выбор одного'
                    }
                ]
            }
        }
    }
</script>